import useMixpanel from "./useMixpanel";
import type { MixpanelData } from "./useMixpanel.d";

export default useMixpanel;
export { MixpanelData };
